import Axios from "axios";
import CONFIG from "../../../model/TSConfig";
import { BusinessUserProfileForm } from "@tootsweet/model/entities/BusinessUserProfileForm";

export default class LoginV2API {
  public static async generateCustomer(
    email: string,
    tz?: string,
    subscriptionPromoCode2?: string,
    locale?: string,
    profileForm?: BusinessUserProfileForm,
    planId?: string | null
  ): Promise<void> {
    await Axios({
      method: "POST",
      url: `${CONFIG.saasBackendUrl}/auth/generate`,
      data: { email, subscriptionPromoCode2, tz, locale, profileForm, planId }
    });
  }

  public static async resendCode(email: string): Promise<void> {
    await Axios({
      method: "POST",
      url: `${CONFIG.saasBackendUrl}/auth/generate`,
      data: { email }
    });
  }

  public static async validateCode(
    code: string,
    email: string,
    planId: string | null
  ): Promise<{
    token: string;
    redirectLink: string | null;
  }> {
    const res = await Axios({
      method: "POST",
      url: `${CONFIG.saasBackendUrl}/auth/validate`,
      data: { code, email, planId }
    });

    return res.data;
  }
}
